import styled, { css } from 'styled-components';
import { Overlay } from '@fluentui/react';
import { Combobox, RadioGroup } from '@fluentui/react-components';
import { TeamWidgetSearchBox } from 'src/components/Timeoff/widgets/TeamWidget/styles/TeamWidgetAutocomplete.styled';
import { DropdownStyled } from '../../SkillsWidgetsContainer/style/SkillsWidget.style';
import { Dismiss20Filled } from '@fluentui/react-icons';
import { isMobile } from 'react-device-detect';

export const SkillsAddPopupOverlay = styled(isMobile ? styled.div`` : Overlay)`
  background: ${(props) => props.theme.skillsAccordionBackground};
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
  width: 420px;
  height: fit-content;
  margin: auto;
  overflow-x: hidden;
  border-radius: 2px;

  @media (max-width: 710px) {
    height: 100svh;
    width: 100%;
    overflow-y: scroll;

    p {
      font-size: 17px;
      font-weight: 400;
      color: #424242;
    }
  }
`;

const isDisplayed = css`
  p {
    color: ${(props) => props.theme.skillsButtonsColor} !important;
  }
`;

const notDisplayed = css`
  span {
    pointer-events: none;
    color: transparent;
  }
`;

export const SkillsTopContainer = styled.div<{ displayCondition?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5%;

  h1 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 5%;
    margin-left: 2rem;
  }
  svg,
  p {
    margin-bottom: 5%;
    margin-right: 2rem;
    cursor: pointer;
  }
  span {
    margin-bottom: 5%;
    margin-right: 2rem;
    cursor: pointer;
    color: #5b5fc7;
    font-size: 16px;
    font-weight: 500;
  }

  @media (max-width: 710px) {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      margin-left: 16px;
      margin-bottom: 0;
      margin-bottom: 5%;
      margin-left: 2rem;
    }
    ${({ displayCondition }) => {
      if (!displayCondition) {
        return notDisplayed;
      } else {
        return isDisplayed;
      }
    }}
  }
`;

export const SkillsMiddleContainer = styled.div<{ isExpanded?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 8px;
  &:first-child {
    margin-bottom: 16px;
  }
  gap: 12px;
  ${({ isExpanded }) => {
    if (isExpanded) {
      return 'padding-bottom: 150px;';
    }
  }}

  @media (max-width: 710px) {
    ${({ isExpanded }) => {
      if (isExpanded) {
        return 'padding: 16px 32px;';
      }
    }}
  }
`;

export const SkillsSearchBox = styled(TeamWidgetSearchBox)`
  position: relative;
  top: unset;
  left: unset;
  right: unset;
  bottom: unset;
  width: 100%;
  margin-top: 14px;
  margin-bottom: 4px;
`;

export const SkillsSelectListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;

export const SkillsSelectList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  margin-bottom: -15.5px;
  height: 37.5vh;
`;

export const SkillsSelectHeader = styled.h1`
  font-size: 14px;
  font-weight: 700;
  padding-left: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 2px solid #5b5fc7;
`;

export const SkillItem = styled.li<{ isSelected: boolean }>`
  ${({ isSelected }) => {
    if (isSelected) {
      return 'background-color: #F5F5F5;';
    }
  }}
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  padding: 10px;
  font-size: 14px;
`;

export const FinishingActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  p {
    margin-right: auto;
    color: #5b5fc7;
    cursor: pointer;
  }

  @media (max-width: 710px) {
    width: 100%;
    height: 64px;
    padding: 0px 20px;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    position: fixed;
    bottom: 0;
    background: ${(props) => props.theme.skillsAccordionBackground} !important;
  }
`;

export const RadioGroupStyled = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 20px;
  margin: auto;
  width: 300px;
  padding: 0;

  span {
    padding: 0;
  }
  input {
    width: 20px;
  }
  label {
    font-size: 13px;
  }

  @media (max-width: 710px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
`;

export const DropdownStyledPopup = styled(DropdownStyled)`
  width: 100%;
`;

export const SelectASkillImageStyled = styled.img`
  width: 50%;
  height: 50%;
  object-fit: cover;
`;

export const ComboboxStyled = styled(Combobox)`
  select {
    max-height: 250px;
  }
`;

export const SkillsBottomContainerMobile = styled.div`
  padding: 0 32px;
  padding-bottom: 62px;
  position: relative;
`;

export const SkillsLevelRadioGroupContainer = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid #e8ebfa;
`;

export const SkillsAttitudeRadioGroupContainer = styled.div`
  padding: 16px 0;
`;

export const SkillsLevelExplanationText = styled.p`
  color: ${(props) => props.theme.skillsLevelTextColor} !important;
  font-size: 12px !important;
  font-weight: 400 !important;
`;

export const RadioButtonContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
`;

export const DismissIcon = styled(Dismiss20Filled)`
  margin-left: auto;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-left: 0;
  margin-bottom: 8px;
`;

export const ComboboxStyle = styled(Combobox)`
  ::placeholder {
    font-size: 16px;
  }
  input {
    font-size: 16px;
  }
`;

export const OptionsWrapper = styled.div`
  max-height: 250px;
`;
